"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Ellipsis = exports.NextIcon = exports.PrevIcon = exports.Next = exports.Prev = exports.ListLink = exports.List = exports.Nav = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Link = _interopRequireDefault(require("../Link"));

var _Icon = _interopRequireDefault(require("../Icon"));

var iconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '3.2rem',
  height: '3.2rem',
  borderRadius: '50%',
  cursor: 'pointer',
  '&:hover': {
    transition: 'all .2s ease-in-out'
  }
};
var iconStyles = (0, _styled.default)(_Icon.default)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      pagination = _ref$theme.pagination;
  return {
    width: '21px',
    height: 'auto',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    svg: {
      stroke: colors[pagination.iconColor]
    },
    '&:hover svg': {
      stroke: colors[pagination.iconColorHover]
    }
  };
});
var Nav = (0, _styled.default)('nav')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
exports.Nav = Nav;
var List = (0, _styled.default)('ul')({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex'
});
exports.List = List;
var ListLink = (0, _styled.default)(_Link.default)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      colors = _ref2$theme.colors,
      pagination = _ref2$theme.pagination,
      isCurrentPage = _ref2.isCurrentPage;
  return {
    padding: "0 ".concat(space.base),
    width: '3.2rem',
    height: '3.2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    fontSize: '1.4rem',
    backgroundColor: isCurrentPage ? colors[pagination.currentLinkBgColor] : colors.none,
    span: {
      color: isCurrentPage ? colors[pagination.currentLinkColor] : colors[pagination.linkColor]
    },
    '&:hover': {
      backgroundColor: isCurrentPage ? colors[pagination.currentLinkBgColorHover] : colors[pagination.linkBgColorHover],
      transition: 'all .2s ease-in-out',
      span: {
        color: isCurrentPage ? colors[pagination.currentLinkColorHover] : colors[pagination.linkColor]
      }
    }
  };
});
exports.ListLink = ListLink;
var Prev = (0, _styled.default)(_Link.default)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      pagination = _ref3$theme.pagination;
  return _objectSpread(_objectSpread({}, iconWrapperStyles), {}, {
    backgroundColor: colors.none,
    '&:hover': {
      backgroundColor: colors[pagination.linkBgColorHover],
      transition: 'all .2s ease-in-out'
    }
  });
});
exports.Prev = Prev;
var Next = (0, _styled.default)(_Link.default)(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      pagination = _ref4$theme.pagination;
  return _objectSpread(_objectSpread({}, iconWrapperStyles), {}, {
    backgroundColor: colors.none,
    '&:hover': {
      backgroundColor: colors[pagination.linkBgColorHover],
      transition: 'all .2s ease-in-out'
    }
  });
});
exports.Next = Next;
var PrevIcon = (0, _styled.default)(iconStyles)({
  transform: 'rotate(90deg)',
  left: '-1px'
});
exports.PrevIcon = PrevIcon;
var NextIcon = (0, _styled.default)(iconStyles)({
  left: '1px'
});
exports.NextIcon = NextIcon;
var Ellipsis = (0, _styled.default)('li')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '3.2rem',
  height: '3.2rem'
});
exports.Ellipsis = Ellipsis;